




































import Vue from 'vue'
import Component from 'vue-class-component'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import { ColorPreviewType } from '../Survey/Utilities/ColorUtility'
import { DefaultBranding } from '../Survey/Utilities/StaticColors'
import ColorConfigSection from './ColorConfigSection.vue'
import { Button } from '@alpha/ink'
import ChartPreview from './ChartPreview.vue'
import { ColorBranding } from '@/store/modules/workspace-store-module'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {
    SettingsCard,
    ChartPreview,
    Button,
    ColorConfigSection
  }
})
export default class ColorSettings extends Vue {
  @Prop({ required: true, default: () => DefaultBranding() }) colorBranding!: ColorBranding
  @Prop({ required: false, default: false }) saving!: boolean

  singleColor: string = this.colorBranding.monochromatic
  sequentialColor: string = this.colorBranding.sequentialPalette
  qualitativePalette: string[] = this.colorBranding.qualitativePalette.slice()
  divergentPalette: string[] = this.colorBranding.divergentPalette.slice()

  editing: boolean = false

  // Open to tips here to dry this up, if I don't assign these variables at declaration
  // (by calling resetPalettes in the constructor f.e.), then the properties aren't
  // treated as reactive for some reason.
  setPalettes (colorBranding: ColorBranding) {
    this.singleColor = colorBranding.monochromatic
    this.sequentialColor = colorBranding.sequentialPalette

    this.qualitativePalette = colorBranding.qualitativePalette.slice()
    this.divergentPalette = this.colorBranding.divergentPalette.slice()
  }

  @Watch('colorBranding', { deep: true })
  resetPalettes () {
    this.setPalettes(this.colorBranding)
  }

  get monochromaticPalette () {
    return [this.singleColor]
  }

  updateSingleColor (palette: string[]) {
    this.singleColor = palette[0]
  }

  get sequentialPalette () {
    return [this.sequentialColor]
  }

  updateSequentialColor (palette: string[]) {
    this.sequentialColor = palette[0]
  }

  updateDivergentPalette (palette: string[]) {
    this.divergentPalette = palette
  }

  updateQualitativePalette (palette: string[]) {
    this.qualitativePalette = palette
  }

  toggleEdit () {
    this.editing = true
  }

  saveColors () {
    // Give the color picker a chance to update colors before we send off the branding to be saved at db
    // this allows saving palette when you have a picker open
    setTimeout(() => {
      this.editing = false
      this.$emit('save', this.branding)
    }, 50)
  }

  cancel () {
    this.editing = false
    this.resetPalettes()
  }

  revertColors () {
    this.setPalettes(DefaultBranding())
  }

  get branding (): ColorBranding {
    return {
      monochromatic: this.singleColor,
      sequentialPalette: this.sequentialColor,
      divergentPalette: this.divergentPalette,
      qualitativePalette: this.qualitativePalette
    }
  }

  get divergent () {
    return ColorPreviewType.Divergent
  }

  get sequential () {
    return ColorPreviewType.Sequential
  }

  get qualitative () {
    return ColorPreviewType.Qualitative
  }

  get monochromatic () {
    return ColorPreviewType.Monochromatic
  }
}
